import { AllowedItineraryModesToHold } from '../constants';

const checkItineraryCanHold = (itinerary) => {
  if (!itinerary) return false;
  if (AllowedItineraryModesToHold.indexOf(itinerary.mode) === -1) return false;
  return true;
};

export default checkItineraryCanHold;
